import $ from 'jquery';
import {getDefaultExposure} from './player-helper';

class NumberConverter {
    constructor(value) {
        this.value = value;
    }

    get() {
        return this.value;
    }

    positive() {
        if (0 > this.value) {
            this.value = this.value * -1;
        }
        return this;
    }

    limitByRange(min, max, firstDefaultValue, secondDefaultValue) {
        if (min > this.value) {
            this.value = firstDefaultValue;
        } else if (max < this.value) {
            this.value = typeof secondDefaultValue === 'undefined' ? firstDefaultValue : secondDefaultValue;
        }
        return this;
    }

    round(number) {
        this.value = Math.round(this.value / number) * number;
        return this;
    }
}

let NumberHelper = {
    isNumeric(value) {
        return /^\d+$/.test(value);
    },
    getRandomInt(min, max, needToFloor = true) {
        let value = Math.random() * (max - min);
        if (needToFloor) {
            value = Math.floor(value);
        }
        return value + min;
    },
    prepareInt(rawValue, defaultValue = null) {
        let value = parseInt(rawValue);
        if (!$.isNumeric(value)) {
            value = defaultValue;
        }

        return new NumberConverter(value);
    },
    prepareFloat(rawValue, toFixed, defaultValue = 0) {
        const value = $.isNumeric(rawValue) ? toFloat(rawValue, toFixed) : defaultValue;

        return new NumberConverter(value);
    },
    int(rawValue, defaultValue = 0) {
        return NumberHelper.prepareInt(rawValue, defaultValue).get();
    },
    float(rawValue, toFixed, defaultValue = 0) {
        return NumberHelper.prepareFloat(rawValue, toFixed, defaultValue).get();
    },
};

export default NumberHelper;

export function toFloat(value, fractionDigits) {
    return parseFloat(value).toFixed(fractionDigits) * 1;
}

export function parsePlayerExposureValue(value, type) {
    return NumberHelper.prepareInt(value, getDefaultExposure(type))
        .limitByRange(getDefaultExposure('min'), getDefaultExposure('max'), getDefaultExposure(type))
        .get();
}

export function parsePlayerPointsValue(value) {
    return NumberHelper.float(value, 3, 0);
}

export function round(x, decimalPlacesCount = 0) {
    const multiplier = 10 ** decimalPlacesCount;

    return Math.round(x * multiplier) / multiplier;
}

export function avg(arr) {
    return arr.reduce((a, b) => a + b, 0) / arr.length;
}

export function isNumeric(value) {
    return $.isNumeric(value);
}
